import React from "react";
import { Responsive, Title, translate } from "react-admin";
import { compose } from "recompose";
import HelpContent from "./HelpContent";

const styles = {
  flexColumn: { display: "flex", flexDirection: "column" },
  leftCol: { flex: 1, marginRight: "1em" },
  rightCol: { flex: 1, marginLeft: "1em" },
  singleCol: { marginTop: "2em", marginBottom: "2em" },
};

const renderSection = (translate) => {
  // Helpに載せる項目一覧
  const content = [
    {
      target: "_blank", // 新規タブ
      title: "help.manual",
      url: "https://resource-booking-service.helpdocsonline.com/home",
      label: "help.manualTitle",
    },
    {
      title: "other.title",
      url: "/oss",
      label: "other.oss",
    },
  ];

  return (
    <div style={styles.flexColumn}>
      <div style={styles.singleCol}>
        {content.map((c) => (
          <HelpContent key={c.title + c.label} content={c} />
        ))}
      </div>
    </div>
  );
};

const Help = ({ translate }) => (
  <>
    <Title title={"help.title"} />
    <Responsive
      xsmall={renderSection(translate)}
      small={renderSection(translate)}
      medium={
        <div style={{ ...styles.flexColumn, display: "flex" }}>
          <div style={styles.leftCol}>{renderSection(translate)}</div>
        </div>
      }
    />
  </>
);

const enhance = compose(translate);

export default enhance(Help);
